import React from 'react'
import { observer } from 'mobx-react-lite'
import classNames from 'classnames'

// evertel
import { DisplayRoomMessage, DisplayThreadMessage } from '@evertel/stores'
import { Icon } from '@evertel/web/ui'
import { DocumentTile, useDocumentModal } from '@evertel/web/document'
import { parsedContent } from '../../../utils/message'

interface DocumentMessageBodyProps {
    message: DisplayRoomMessage | DisplayThreadMessage
    highlightString?: string
}

const DocumentMessageBody: React.FC<DocumentMessageBodyProps> = observer(({
    message,
    highlightString
}) => {
    const { openDocumentModal } = useDocumentModal()
    const documentId = (message.meta as { documentId?: number })?.documentId

    return (
        <>
            {message.text && (
                <div style={{ display: 'flex', alignItems: 'center' }} className="mb-2">
                    {message.isUrgent && (
                        <span className="urgent-icon">
                            <Icon name="triangle-exclamation" />
                        </span>
                    )}
                    <div
                        dangerouslySetInnerHTML={{ __html: parsedContent(message.text, highlightString) }}
                        className={classNames('post-content', { 'urgent': message.isUrgent })}
                        style={{ display: 'inline-block' }}
                    />
                </div>
            )}
            <DocumentTile
                documentId={documentId}
                onClick={openDocumentModal}
                className="m-0"
            />
        </>
    )
})

DocumentMessageBody.displayName = 'DocumentMessageBody'

export { DocumentMessageBody }
